<template>
  <!--查看-->
  <div :class="`orderEditBlock ${isStatus ? 'margin-l-20' : ''}`">
    <el-form :class="`order-edit-form ${isStatus ? 'max-h-700' : ''}`" :model="formData" :rules="rules" v-loading="saveLoading" ref="orderEditForm" :label-width="'100px'" label-position="top">
      <el-row :gutter="10">
        <el-col :span="12">
          <div class="cnt-block">
            <div class="cnt-top-title">
              <div class="cnt-title">预订人信息</div>
            </div>
            <div class="cnt-items">
              <el-form-item prop="bookerName" label="预订人" class="cnt-item-name m-r-10">
                <el-input v-model="formData.bookerName" placeholder="请输入" :disabled="showType == 'edit' && detailData.orderState!==1"></el-input>
              </el-form-item>
              <el-form-item prop="bookerPhone" label="" class="cnt-item-phone">
                <el-input class="m-t-30" v-model="formData.bookerPhone" placeholder="请输入手机号码" :disabled="showType == 'edit' && detailData.orderState!==1"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="cnt-block">
            <div class="cnt-title">房源信息</div>
            <div class="cnt-items">
              <el-form-item prop="roomTypeId" label="房型" class="cnt-item-name m-r-10">
                <span v-if="isStatus">{{ formData.roomTypeName }}</span>
                <el-select v-else v-model="formData.roomTypeId" :disabled="showType=='edit'" filterable placeholder="请选择" @change="handleChangeRoomType">
                  <el-option v-for="item in selOptions.roomType" :key="item.roomTypeCode"  :label="item.roomTypeName" :value="item.id+''">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="roomId" label="房源名称" class="cnt-item-phone">
                <span v-if="isStatus">{{ formData.roomName }}</span>
                <el-select v-else v-model="formData.roomId"  :disabled="showType=='edit'" filterable placeholder="请选择">
                  <el-option v-for="item in roomSelOptions" :key="item.roomCode"  :label="item.roomName" :value="item.id+''">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <div class="cnt-block cnt-block-blue">
            <div class="cnt-title">
              <span>订单信息</span>
              <div class="title-extra" v-if="showType != 'edit'">
                <el-radio v-model="formData.orderType" :label="1">全日房</el-radio>
                <el-radio v-model="formData.orderType" :label="2">钟点房</el-radio>
              </div>
              <div class="title-extra cnt-sub-title" v-else>注：此订单信息为{{formData.orderType == 1 ? '全日房订单信息' : '钟点房订单信息'}}</div>
            </div>
            <div class="cnt-content-container">
              <el-row :gutter="10">
                <el-col :span="17">
                  <span class="el-form-item__label">订单编号：</span>
                  <span class="el-form-item__label">{{ showType == 'add' ? '--' : detailData.orderCode }}</span>
                </el-col>
                <el-col :span="7" class="flex">
                  <div class="el-form-item__label">订单来源</div>
                  <el-form-item prop="orderSource">
                    <el-select v-model="formData.orderSource"  :disabled="showType=='edit'" filterable placeholder="请选择" >
                      <el-option v-for="item in selOptions.platform" :key="item.platformCode"  :label="item.platformName" :value="item.platformCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="17" class="flex">
                  <span class="el-form-item__label">入住时间：</span>
                  <el-form-item prop="proposedCheckInTime" >
                    <el-date-picker
                      v-model="formData.proposedCheckInTime"
                      class="w-i-180"
                      :disabled="!editFlags.time"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      value-format="YYYY-MM-DD HH:mm"
                      placeholder="选择日期"
                      :clearable="false"
                      :picker-options="pickerOptions1"
                      @change="pickTimeChange"
                    >
                    </el-date-picker>
                    <div class="time-tip" >入住</div>
                  </el-form-item>
                  <div class="el-form-item__label m-l-10">{{ formData.timeStr ? formData.timeStr : '--' }}</div>
                  <el-form-item prop="proposedCheckOutTime">
                    <el-date-picker
                      v-model="formData.proposedCheckOutTime"
                      class="w-i-180"
                      :disabled="!editFlags.time"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      value-format="YYYY-MM-DD HH:mm"
                      placeholder="选择日期"
                      style="width: 100%;"
                      :clearable="false"
                      :picker-options="pickerOptions2"
                      @change="pickTimeChange"
                    >
                    </el-date-picker>
                    <div class="time-tip" >离店</div>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <span class="el-form-item__label">房费</span>
                  <span>¥：{{ formData.orderPrice }}</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="cnt-block cnt-block-blue">
        <div class="cnt-title">
          <span>入住信息</span>
          <div class="title-extra">
            <div class="personOperate person-add-perate" @click="handleAddStayPerson">
              <el-image :src="require('@/assets/img/order/person_add.png')"></el-image>
              <span class="add-text">新增入住人</span>
            </div>
          </div>
        </div>
        <div class="cnt-content-container">
          <el-row :gutter="10" class="m-b-10">
            <el-col :span="4">
              <div class="required-div el-form-item__label align-l">证件类型</div>
            </el-col>
            <el-col :span="4">
              <div class="required-div el-form-item__label align-l">入住人</div>
            </el-col>
            <el-col :span="4">
              <div class="required-div el-form-item__label align-l">证件号码</div>
            </el-col>
            <el-col :span="4">
              <div class="required-div el-form-item__label align-l">手机号</div>
            </el-col>
            <el-col :span="5">
              <div class="el-form-item__label align-l">民族</div>
            </el-col>
            <el-col :span="3">
              <div class="el-form-item__label align-c">操作</div>
            </el-col>
          </el-row>
          <el-row class="m-b-20" :gutter="10" v-for="(item, index) in formData.checkInPersonInfoDTOS" :key="'person_' + index">
            <el-col class="flex-a-c" :span="4">
              <el-form-item :prop="'checkInPersonInfoDTOS.' + index + '.certificateType'">
                <el-select v-model="item.certificateType" :disabled="item.verificationStatus == 2" filterable placeholder="请选择">
                  <el-option v-for="item in selOptions.certType" :key="item.name"  :label="item.value" :value="item.name+''">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="flex-a-c" :span="4">
              <el-form-item :prop="'checkInPersonInfoDTOS.' + index + '.personName'">
                <el-input v-model="item.personName" :disabled="item.verificationStatus == 2" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="flex-a-c" :span="4">
              <el-form-item :prop="'checkInPersonInfoDTOS.' + index + '.certificateNumber'">
                <el-input v-model="item.certificateNumber" :disabled="item.verificationStatus == 2" placeholder="证件号码"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="flex-a-c" :span="4">
              <el-form-item :prop="'checkInPersonInfoDTOS.' + index + '.personPhone'" :rules="rules.personPhone">
                <el-input v-model="item.personPhone" :disabled="item.verificationStatus == 2" placeholder="联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :prop="'checkInPersonInfoDTOS.' + index + '.nationality'" :rules="rules.nationality">
                <el-select v-model="item.nationality" :disabled="item.verificationStatus == 2" placeholder="民族">
                  <el-option 
                    v-for="(nation, i) of nationList" 
                    :key="i"
                    :value="nation.name"
                    :label="nation.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <div v-if="item.canDel" class="personOperate person-del-perate" @click="formData.checkInPersonInfoDTOS.splice(index, 1)">
                <el-image :src="require('@/assets/img/order/person_del.png')"></el-image>
                <span>删除</span>
              </div>
              <div v-if="item.verificationStatus == 2 " class="personOperate person-cert-perate">
                <el-icon size="18"><circle-check-filled /></el-icon>
                <div class="ok-text">已认证</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="cnt-block">
        <div class="cnt-title">备注信息</div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item prop="remark" class="w-p-100">
              <el-input type="textarea" :rows="3" v-model="formData.remark"  :disabled="showType=='edit'" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="form-footer">
      <el-row :gutter="10">
        <el-col :span="14">
          <div class="order-type m-b-10">
            <span>订单类型：</span>
            <span>{{ formData.orderType == 1 ? '全日房' : '钟点房' }}</span>
          </div>
          <div class="room-price flex">
            <span>房费：</span>
            <span v-if="!isEditPrice" class="price">￥{{ formData.orderPrice }}</span>
            <el-input-number v-else v-model="orderPrice" :min="0" controls-position="right" />
            <el-button class="color-pri" icon="Edit" type="text" @click="isEditPrice = !isEditPrice">{{ isEditPrice ? '取消' : '手动修改' }}</el-button>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex-bottom w-p-100 h-p-100">
            <el-button class="submit-btn" @click="handleSave">保存</el-button>
            <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import RichText from "@/components/common/RichText/RichText";
  import { mapActions } from 'vuex'
  import moment from 'moment'
  import formCheck from '@/components/common/formCheck'
  import orderMix from './mixin.js'
  import mixin from './mixin'

  import imgTripCode from '@/assets/img/imgs/img-upload-trip-code.png'
  import imgHealthCode from '@/assets/img/imgs/img-upload-health-code.png'

  export default {
      components: {
        RichText
      },
      mixins: [ formCheck,orderMix, mixin],
      name: "publishDetailModel",
      props:{
        selOptions: {
          type: Object,
          default: () => ({
            rooms: [],
            roomType: [],
            platform: [],
            certType: [],
            orderType: [
              { code: 1, name: '全日房' },
              { code: 2, name: '钟点房' }
            ]
          }),
        },
        selMapsWyfbm:{
          type: Object,
          default:{}
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        },
        isStatus: {
          type: Boolean,
          default: false
        },
        defaultData: {
          type: Object,
          default: () => ({})
        }
      },
      data(){
        let detailKeys = [
          'roomTypeId', 'orderState', 'timeType', 'orderType', 'bookerName', 'orderPrice',
          'bookerPhone', 'remark', 'roomId', 'roomName', 'proposedCheckInTime', 'proposedCheckOutTime', 'orderSource'
        ]

        let formData = {}
        detailKeys.map((key) => {
          formData[key] = ''
        })
        formData.orderPrice = 0
        formData.checkInPersonInfoDTOS = [
          { certificateNumber:'',certificateType:'',personName: '', personPhone: '', healthCode: '', tripCode: '', canEdit: true, canDel: true, orderCode: '' }
        ]

        let validateTel = (rule, value, callback) => {
          if (value.trim()!='' && !this.checkTelNum(value)) {
            callback(new Error('格式错误'));
          } else {
            callback();
          }
        };
        return{
          nationList: [],
          Authorization: localStorage.getItem('Authorization'),
          isEditPrice: false, // 是否编辑房费

          healthCodeUploadUrl: location.origin + '/apiapi/web/order-info/pandemicPic',
          uploadUrl: location.origin + '/saas/api/web/fileStorage/upload',

          imgTripCode,
          imgHealthCode,

          showType: '',
          orderPrice: 0,
          saveLoading: false,
          detailKeys: detailKeys,
          roomSelOptions: [],

          rules: {
            roomTypeId:[{ required: true, message: '请输入', trigger: 'blur' }],
            roomId:[{ required: true, message: '请输入', trigger: 'blur' }],
            proposedCheckOutTime:[{ required: true, message: '请选择', trigger: 'change' }],
            proposedCheckInTime:[{ required: true, message: '请选择', trigger: 'change' }],
            orderType:[{ required: true, message: '请输入', trigger: 'blur' }],
            orderSource:[{ required: true, message: '请输入', trigger: 'blur' }],
            bookerName: [{ required: true, message: '请输入', trigger: 'blur' }],
            bookerPhone:[{ required: true, message: '请输入', trigger: 'blur' },{ validator: validateTel, trigger: 'blur' }],
            personName:[{ required: true, message: '请输入', trigger: 'blur' }],
            personPhone:[{ validator: validateTel, trigger: 'blur' }],
           
          },
          pickerOptions1:{
            disabledDate(time) {
              return time.getTime() < Date.now();
            },
          },
          pickerOptions2:{
            disabledDate(time) {
              return time.getTime() < Date.now() ;
            },
          },

          formData,
          editFlags: {time:true}
        }
    },
    mounted(){
      this.showType = this.detailType
      this.getNationList();
    },
    watch:{
      detailType(val) {
        this.showType = val
      },
      detailModal: {
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          this.$nextTick(()=>{
            this.$refs.orderEditForm.resetFields()
            this.initFormData()
            this.initEditFlags()
            // this.pickTimeChange()
          })
        }
      },
      'formData.orderType'(val) {
        this.handleOrderTypeChange()
        // this.pickTimeChange(val)
      }
    },
    methods:{
      ...mapActions([ 'fetchData', 'upload' ]),
      getNationList(){
        this.fetchData({ 
          url: 'SYSTEM.DICT.GET_LIST', 
          method: 'get', 
          params : {
            type: 'nationality',
            pageNumber: 1,
            pageSize: 100,
          }
        }).then((res) => {
          this.nationList = res.data;
        })
        .catch((err) => {
        })
      },
      //初始化可编辑项
      initEditFlags(){
        if(this.detailType=='add' || this.detailType=='reserveAgain'){
          this.editFlags = {time:true}
        }else{
          //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效。目前房东没有退房权限
          this.editFlags = {
            time:this.detailData.orderState==1?true:false,
          }
        }  
      },
      //初始化表单数据
      initFormData(){
        if(this.detailType=='add'){
          this.detailKeys.map((key)=>{
            this.formData[key] = ''
          })

          this.formData.orderType = 1
          this.formData.checkInPersonInfoDTOS = [{certificateNumber:'',certificateType:'',personName:'',personPhone:'', healthCode: '', tripCode: '', canEdit:true,canDel:true,orderCode:''}]

          // 这里是从房态跳转过来的，默认值设置逻辑
          if (this.isStatus) {
            this.formData.roomTypeId = this.defaultData.roomTypeId
            this.formData.roomTypeName = this.defaultData.roomTypeName
            this.formData.roomId = this.defaultData.roomId
            this.formData.roomName = this.defaultData.roomName
            let date = this.defaultData.proposedCheckInTime
            this.handleOrderTypeChange(date)
            this.initRoomSels()
          } else {
            //下拉框的值初始化
            if(this.selOptions.roomType && this.selOptions.roomType.length){
              this.formData.roomTypeId =  this.selOptions.roomType[0].id+''
            }else{
              this.formData.roomTypeId = ''
            }

            this.handleOrderTypeChange()
            this.initRoomSels(true)
          }

          let roomPriceParams = {
            nightNum: this.getDiffTime(this.formData.proposedCheckInTime, this.formData.proposedCheckOutTime, 1),
            endTime: this.formData.proposedCheckOutTime,
            startTime: this.formData.proposedCheckInTime,
            roomTypeId: this.formData.roomTypeId,
            isHourRoom: false,
          }
          this.getRoomPrice(roomPriceParams, price => {
            this.orderPrice = price
            this.formData.orderPrice = price
          })
        }
        if (this.detailType=='edit' || this.detailType=='reserveAgain') {
          this.detailKeys.map((key)=>{
            this.formData[key] = this.detailData[key] ? this.detailData[key]:''
          })
          this.formData.orderPrice = this.formData.orderPrice || 0
          this.orderPrice = this.formData.orderPrice
          this.initRoomSels(false)
          if(this.detailType=='reserveAgain'){
            this.handleOrderTypeChange()
          }
          
          //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效。目前房东没有退房权限,入住中已认证的入住人不能删除
          if(this.detailData.checkInPersonInfoDTOS && this.detailData.checkInPersonInfoDTOS.length){
            let persons = this.detailData.checkInPersonInfoDTOS
            persons.forEach((item)=>{
              if(this.detailType=='edit'){
                item.canDel = (this.detailData.orderState==3 && item.verificationStatus==2) ? false:true
                if(item.picId){
                  item.healthCode = {id:item.picId,url:item.picUrl}
                }
                if(item.travelCodeId){
                  item.tripCode = {id:item.travelCodeId,url:item.travelCodeUrl}
                }
                //item.canEdit = (this.detailData.orderState==3 && item.verificationStatus==2) ? false:true
              }else if(this.detailType=='reserveAgain'){
                item.canDel = true
                if(item.picId){
                  item.healthCode = {id:item.picId,url:item.picUrl}
                }
                if(item.travelCodeId){
                  item.tripCode = {id:item.travelCodeId,url:item.travelCodeUrl}
                }
                //item.canEdit = true
              }
            })
            this.formData.checkInPersonInfoDTOS = [...persons]
          }else{
            this.formData.checkInPersonInfoDTOS = [{certificateNumber:'',certificateType:'',personName:'',personPhone:'', healthCode: '', tripCode: '', canEdit:true,canDel:true,orderCode:this.detailData.orderCode}]
          }
        }
        this.$nextTick(()=>{
          this.initEditFlags()
        })
      },
      //保存与发布
      handleSave(){
        if (this.saveLoading) return

        this.saveLoading = true
        this.trimFormData()
        if(new Date(this.formData.proposedCheckOutTime).getTime() <= new Date(this.formData.proposedCheckInTime).getTime()){
          this.$message.error('拟离开日期必须大于预定入住日期')
          this.saveLoading = false
          return false
        }
        this.$refs['orderEditForm'].validate((valid) => {
          if (valid) {
            this.doSave()
          } else {
           // this.$message.error('输入不合法！')
            this.saveLoading = false
            return false;
          }
        });
      },
      doSave(){
        let url = 'SAAS.ORDER_EDIT'
        let paramData = JSON.parse(JSON.stringify(this.formData))
        paramData.checkInPersonInfoDTOS = paramData.checkInPersonInfoDTOS.filter((item)=>{
          return item.personName.trim()!='' 
        })

        let isValid = true
        paramData.checkInPersonInfoDTOS.length && paramData.checkInPersonInfoDTOS.forEach((cItem)=>{
          cItem.picId = cItem.healthCode?.id
          cItem.travelCodeId = cItem.tripCode?.id
          
          if(!cItem.picId && !cItem.travelCodeId){
            isValid = false
          }

          delete cItem.picUrl
          delete cItem.travelCodeUrl
          delete cItem.healthCode
          delete cItem.tripCode
          delete cItem.canDel
          delete cItem.canEdit
          if(this.detailType=='reserveAgain'){
            delete cItem.id
            url = 'SAAS.ORDER_REBOOK';
          }
        })

        // if(!isValid){
        //   this.$message.error('每个入住人的防疫资料必须上传一个')
        //   this.saveLoading = false
        //   return false
        // }

        if(this.detailType=='edit'){
          paramData.id = this.detailData.id
        }else {
          paramData.id = ''
        }

        if (this.isEditPrice) {
          paramData.orderPrice = this.orderPrice
        }

        delete paramData.timeType
        delete paramData.roomTypeId
        delete paramData.timeStr

        this.fetchData({url:url, method: 'post', params:paramData,timeout:0, isLoading:false, headers:{'Content-Type':'application/json'} , flag:true}).then((res)=>{
          if(res.code==200){
            this.$message.success(res.msg||'操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
        }).catch((err)=>{
          this.$message.error(err || '操作失败！')
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
      pickTimeChange(val) {
        let diffs = this.getDiffTime(this.formData.proposedCheckInTime, this.formData.proposedCheckOutTime, this.formData.orderType)
        if (diffs) {
          this.formData.timeStr = (this.formData.orderType == 1) ? diffs + '晚' : diffs + '小时'
          this.setRoomPrice()
        } else {
          this.formData.timeStr = '--'
        }
      },
      // 处理房型变更
      handleChangeRoomType() {
        this.initRoomSels(true)
        this.setRoomPrice()
      },
      // 设置房费
      setRoomPrice() {
        let roomPriceParams = {
          endTime: this.formData.proposedCheckOutTime,
          startTime: this.formData.proposedCheckInTime,
          roomTypeId: this.formData.roomTypeId,
          isHourRoom: this.formData.orderType == 2,
        }

        let time = this.getDiffTime(this.formData.proposedCheckInTime, this.formData.proposedCheckOutTime, this.formData.orderType)
        if (this.formData.orderType == 1) {
          roomPriceParams.nightNum = time
        } else {
          roomPriceParams.hourNum = time
        }

        // 不是新增的 || 修改的，不允许通过其他方式修改房费
        if (this.detailType !== 'add' && this.detailType !== 'edit') return
        this.getRoomPrice(roomPriceParams, price => {
          this.orderPrice = price
          this.formData.orderPrice = price
        })
      },

      //全日房、钟点房切换
      handleOrderTypeChange(date) {
        const curShop = JSON.parse(localStorage.getItem('curShop'));
        date = date || new Date()
        
        if (this.formData.orderType == 1) {
          // if(!this.formData.proposedCheckInTime){
            this.formData.proposedCheckInTime = moment(date).format(`YYYY-MM-DD ${curShop.bookStartTime || "14:00"}`)
          // }
          // if(!this.formData.proposedCheckOutTime){
            this.formData.proposedCheckOutTime = moment(date).add(1, 'days').format(`YYYY-MM-DD ${curShop.bookEndTime || '12:00'}`)
          // }
        } else if (this.formData.orderType == 2) {
          this.formData.proposedCheckInTime = moment(date).add(1, 'hours').format('YYYY-MM-DD HH:00')
          this.formData.proposedCheckOutTime = moment(date).add(curShop.clockRoomHours ? (1 + curShop.clockRoomHours) : 5, 'hours').format('YYYY-MM-DD HH:00')
        }
      },
      //房源变更
      pickRoomTypeChange(){
        this.initRoomSels(true)
      },
      //初始化房源列表
      initRoomSels(flag){
        let val = this.formData.roomTypeId
        let curRooms = []
        this.selOptions.rooms.length && this.selOptions.rooms.forEach((item)=>{
          if(item.roomTypeId == val){
            curRooms.push({...item})
          }
        })
        this.roomSelOptions = curRooms
        if(flag && !this.isStatus){
          this.formData.roomId = curRooms.length?curRooms[0].id:''
        }
      },
      // 添加入住人
      handleAddStayPerson() {
        this.formData.checkInPersonInfoDTOS.push({
          canDel: true,
          canEdit: true,
          certificateNumber:'',
          certificateType:'',
          personName: '',
          personPhone: '',
          healthCode: '',
          tripCode: '', 
          orderCode: this.detailData.orderCode
        })
      },
      // 处理上传
      handleUpload(data) {
        this.curUploadData = data
      },
    },
  }
</script>

<style lang="less" scoped>
.orderEditBlock {
  position: relative;
  margin: 0px -60px;
  overflow-x: hidden;
}
.margin-l-20 {
  margin: 0px -20px;
}
.max-h-700 {
  max-height: 700px !important;
}
.order-edit-form {
  padding: 0px 60px;
  max-height: 600px;
  overflow-y: auto;
}
.form-footer {
  padding: 0px 60px;
  padding-top: 20px;
  .order-type {
    font-size: 16px;
  }
  .room-price {
    align-items: center;
    font-size: 18px;
    .price {
      font-size: 22px;
      font-weight: bold;
      color: #ff4c4c;
    }
  }
}
.cnt-block {
  width: 100%;
}
.cnt-title, .cnt-title > span {
  position: relative;
  font-size: 18px;
  height: 56px;
  line-height: 56px;
  flex:1;
}
.cnt-title .title-extra {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}
.cnt-sub-title {
  padding: 0px 15px;
  height: 27px;
  background-color: #fff5e5;
  border: 1px solid;
  border-color: #ffdeb6;
  color: #f66401;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
}
.cnt-top-title{
  display: flex;
}
.cnt-items{
  display: flex;
  .cnt-item-name{
    width: 103px !important;
  }
  .cnt-item-phone{
    margin-right: 0px;
    flex: 1;
  }
}
.cnt-block-blue{
  margin-bottom: 18px;
}
.cnt-block-blue .cnt-items{
  background: #f1faff;
  padding: 10px;
}
.cnt-items-remark{
  background: #fff !important;
}
.el-form-item :deep(.el-form-item__label),.el-form-item__label{
  font-size: 14px !important;
  font-weight: 600 !important;
}

.personOperate {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: #ff4c4c;
  margin-top:15px;
  .el-image {
    width: 14px;
    height: 16px;
    margin-right: 5px;
    margin-top: 2px;
  }
  .add-text {
    color: #00c0c0;
  }
}
.person-cert-perate {
  color: #00c0c0;
  text-align: center;
}
.person-add-perate, .person-del-perate {
  cursor: pointer;
}


.time-tip{
  margin-left: -50px;
  font-size: 14px;
  color:#555;
  display: none;
}
.source-label{
  margin-left: 20px;
}
.required-div:before {
    content: "*";
    color: var(--el-color-danger);
    margin-right: 4px;
}
.m-t-30{
  margin-top: 30px;
}

.img-code-box {
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
    max-width: 90px;
    max-height: 90px;
  }
}

.cnt-content-container {
  padding: 15px;
  padding-bottom: 10px;
  width: 100%;
  background-color: #f1faff;
  border-radius: 3px;
}
.flex {
  display: flex;
}
.flex-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.flex-a-c {
  display: flex;
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.h-p-100 {
  height: 100%;
}
.color-pri {
  color: rgba(0, 192, 192, 1);
}
</style>

<style lang="less">
.w-i-180 {
  width: 180px !important;
}
</style>